import './style.scss';
import 'mapbox-gl/dist/mapbox-gl.css';
import mapboxgl from 'mapbox-gl';
import $ from 'jquery';
window.$ = $;
window.jQuery = $;

import {InitSelect2} from "../../scripts/initSelect2";

export function our_locations_block() {
  const block = document.querySelector('.our_locations_block');
  if (!block) return;
  
  const mapContainerEl = block.querySelector('.map-container');
  const mapElId = 'map';
  const countryCityMapBase64 = mapContainerEl.getAttribute('data-countryCityMap');
  const mapboxAccessTokenBase64 = mapContainerEl.getAttribute('data-mapbox-access-token');
  
  const countryCityMap = JSON.parse(atob(countryCityMapBase64));
  const mapboxAccessToken = JSON.parse(atob(mapboxAccessTokenBase64));
  
  const $citySelect = $('#city-select');
  const $branchSelect = $('#branch-select');
  const whatsappA = block.querySelector('.whatsapp-number');
  const directionsA = block.querySelector('.directions-link');
  const PIN_SVG = `
<svg width="60" height="81" viewBox="0 0 60 81" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M31.5938 0.0405702C31.0547 0.0135234 30.5223 0 29.9832 0C22.2532 0 14.9815 2.90077 9.34741 8.26955C3.32248 14.0102 0 21.7659 0 30.1031C0 33.3216 0.498708 36.4793 1.48265 39.4748L1.66461 40.1577C6.14624 57.0754 18.1692 71.1668 27.3481 79.93C28.8442 81.3567 31.1962 81.3567 32.6856 79.93C41.8713 71.1533 53.8942 57.0416 58.3556 40.0968V39.9548L58.5376 39.4139C59.508 36.432 60 33.2946 60 30.1098C60.0067 14.0711 47.5256 0.858735 31.5938 0.0338085V0.0405702ZM40.9143 27.7162C41.8578 34.9512 35.7453 41.084 28.5342 40.1374C23.6415 39.495 19.699 35.5192 19.0857 30.6102C18.1894 23.4157 24.248 17.3437 31.4186 18.2363C36.3181 18.8516 40.2741 22.8072 40.9143 27.7162Z" fill="#997352"/>
</svg>
`;
  
  function makeCustomPinEl() {
    const el = document.createElement('div');
    el.className = 'mapbox-custom-pin';
    el.innerHTML = PIN_SVG;
    return el;
  }
  
  let map = null;
  let marker = null;
  mapboxgl.accessToken = mapboxAccessToken;
  
  function initMap(lat, lng) {
    map = new mapboxgl.Map({
      container: mapElId,
      style: 'mapbox://styles/mapbox/light-v11',
      center: [lng, lat],
      zoom: 13,
      attributionControl: true
    });
    map.addControl(new mapboxgl.NavigationControl(), 'top-right');
    
    marker = new mapboxgl.Marker({
      element: makeCustomPinEl(),
      anchor: 'bottom'
    })
        .setLngLat([lng, lat])
        .addTo(map);
    
    setTimeout(() => map.resize(), 150);
  }
  
  function updateMap(lat, lng) {
    const L = parseFloat(lat);
    const G = parseFloat(lng);
    if (Number.isNaN(L) || Number.isNaN(G)) return;
    
    if (!map) {
      initMap(L, G);
    } else {
      marker?.setLngLat([G, L]);
      map.flyTo({center: [G, L], zoom: 14, essential: true});
    }
  }
  
  // ===== Helpers =====
  function ensurePlaceholder($select, placeholderText) {
    const hasEmpty = $select.find('option[value=""]').length > 0;
    if (!hasEmpty) {
      $select.prepend(new Option(placeholderText, '', true, true));
    } else {
      $select.val('');
    }
  }
  
  function populateBranchesForCity(citySlug) {
    const branches = countryCityMap[citySlug] || [];
    $branchSelect.empty();
    $branchSelect.append(new Option('Branch', '', true, true));
    
    branches.forEach((b) => {
      const opt = new Option(b.text, b.value, false, false);
      $branchSelect.append(opt);
    });
    
    $branchSelect.trigger('change.select2');
  }
  
  function getBranchByValue(citySlug, branchValue) {
    const list = countryCityMap[citySlug] || [];
    return list.find((b) => b.value === branchValue) || null;
  }
  
  function updateActionsAndMap(branchObj) {
    if (!branchObj) return;
    
    const digits = String(branchObj.phone_number || '').replace(/\D+/g, '');
    if (digits) {
      whatsappA.href = `https://wa.me/${digits}`;
      whatsappA.setAttribute('target', '_blank');
      whatsappA.setAttribute('rel', 'noopener');
    } else {
      whatsappA.removeAttribute('href');
    }
    
    const lat = branchObj.latitude;
    const lng = branchObj.longitude;
    if (lat && lng) {
      const gmaps = `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`;
      directionsA.href = gmaps;
      directionsA.setAttribute('target', '_blank');
      directionsA.setAttribute('rel', 'noopener');
      
      updateMap(lat, lng);
    } else {
      directionsA.removeAttribute('href');
    }
  }
  
  $citySelect.on('change', function () {
    const citySlug = $(this).val();
    if (!citySlug) {
      $branchSelect.empty()
          .append(new Option('Branch', '', true, true))
          .trigger('change.select2');
      return;
    }
    populateBranchesForCity(citySlug);
  });
  
  $branchSelect.on('change', function () {
    const branchValue = $(this).val();
    const citySlug = $citySelect.val();
    if (!citySlug || !branchValue) return;
    const branchObj = getBranchByValue(citySlug, branchValue);
    updateActionsAndMap(branchObj);
  });
  
  InitSelect2(mapContainerEl);
  
  ensurePlaceholder($citySelect, 'City');
  ensurePlaceholder($branchSelect, 'Branch');
  
  $citySelect.val('').trigger('change.select2');
  $branchSelect.val('').trigger('change.select2');
  
  const firstCitySlug = Object.keys(countryCityMap || {})[0];
  const firstBranch = firstCitySlug ? (countryCityMap[firstCitySlug] || [])[0] : null;
  
  if (firstBranch && firstBranch.latitude && firstBranch.longitude) {
    updateActionsAndMap(firstBranch);
  }
}
